import { SubscriptionObj } from '../../component-helpers/app-details';
import { App } from '../../models/app';

export enum AppDetailsModuleId  {
  Header = 'app-details-header',
  Pricing = 'pricing-and-subscription',
  Ratings = 'ratings-and-reviews',
}

export const AppRelatedTranslationKeys = {
  ChangeSubscription: 'app_details.change_subscription',
  RateApp: 'app_details.rate_this_app',
  ViewSubscription: 'app_details.view-subscription_pricing',
  SubscriptionPricing: 'app_details.subscription_pricing',
  FreeVersionAvailable: 'app_details.free_version_available',
  ByDev: 'by_developer',
  Change: 'buttons.change',
  Notify: 'buttons.notify'
}

export enum ReducerAction  {
  Init= 'INIT',
  SetModalVisibility = 'MODAL_VISIBILITY',
  SetRequiresAnotherPlanError = 'REQUIRE_ANOTHER_PLAN_ERROR',
}

export enum AppDetailsModal {
  Pricing,
  YelpConnect
}

export type AppDetailsState = {
  app?: App;
  openModal?: AppDetailsModal;
  subscriptionObj: Maybe<SubscriptionObj>;
  canShowAggregateRating: boolean;
  hasRatingsAndReviewsEnabled: boolean;
  showRequireAnotherPlanError?: boolean;
}

type SetModalVisibility = {
  type: ReducerAction.SetModalVisibility;
  payload: Maybe<AppDetailsModal>
}

type InitAction = {
  type: ReducerAction.Init;
  payload: {
    app: App;
    subscriptionObj: SubscriptionObj;
    canShowAggregateRating: boolean;
    hasRatingsAndReviewsEnabled: boolean;
  }
}

type SetRequiresAnotherPlanBanner = {
  type: ReducerAction.SetRequiresAnotherPlanError;
  payload: boolean
}


export type AppDetailsActionType = InitAction | SetModalVisibility | SetRequiresAnotherPlanBanner;
